<div class="product-list">
  <swiper-container
    class="product-list-swiper"
    navigation="true"
    slides-per-view="1"
    loop="false"
    edge-swipe-detection="true"
    speed="100"
    long-swipes="true"
    long-swipes-ratio="0.3"
    #productListSwiper
  >
    <swiper-slide
      class="swiper-slide"
      *ngFor="let meal of products; trackBy: listTrackFn"
    >
      <app-product-card
        [@fadeInOut]
        (click)="onProductClicked(meal)"
        [meal]="meal"
        [hideBuyButton]="hideBuyButton"
      ></app-product-card
    ></swiper-slide>
  </swiper-container>

  <div
    class="app-spinner-container"
    *ngIf="products === undefined || products === null"
  >
    <ion-spinner class="app-spinner"></ion-spinner>
  </div>

  <div class="empty-message" *ngIf="products?.length === 0">
    {{ "@components.productList.emptyListMessage" | translate }}
  </div>
</div>
